var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9951 18.757L0.531919 37.0131C-0.15611 37.6934 -0.15611 38.7964 0.531918 39.4767L0.54789 39.4925C1.23592 40.1728 2.35143 40.1728 3.03946 39.4925L21.5026 21.2364C22.1907 20.5561 22.1907 19.4531 21.5026 18.7728L21.4867 18.757C20.7986 18.0767 19.6831 18.0767 18.9951 18.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.532265 0.500932L0.516293 0.516725C-0.171735 1.19704 -0.171735 2.30004 0.516294 2.98035L18.9795 21.2364C19.6675 21.9167 20.783 21.9167 21.471 21.2364L21.487 21.2206C22.175 20.5403 22.175 19.4373 21.487 18.757L3.02384 0.500933C2.33581 -0.179378 1.22029 -0.179378 0.532265 0.500932Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormArrow);
export default __webpack_public_path__ + "static/media/formArrow.8e119087a337b52672d0aa3b1b75dbcb.svg";
export { ForwardRef as ReactComponent };